import { TableCell, TableRow } from "@mui/material";
import { CopyToClipboard } from '../../../../../utilities/utilities'
import { MdOutlineContentCopy } from "react-icons/md";
import { Box } from '@mui/material'
import { width } from "@mui/system";

export function NodesRows(props: any) {
    console.log(props)
    return (
        <>
            <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
                <TableCell style={{ textAlign: 'left' }} >
                    <Box style={{display:'flex', flexDirection:'row',cursor:"pointer", width:"fit-content"}} onClick={() => CopyToClipboard(props.address)}>
                        {props.address.substring(0, 6) + '...' + props.address.substring(props.address.length - 6)}
                        <MdOutlineContentCopy style={{ marginLeft: '4px' }} />
                    </Box>
                </TableCell>
                <TableCell style={{ textAlign: 'left' }}>
                    {props?.ccntp}
                </TableCell>
                <TableCell style={{ textAlign: 'left' }}>
                    {props?.cntp}
                </TableCell>
            </TableRow>
        </>
    )
}